/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6ab24ecc-7a05-44ec-9472-2457191a5938",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_tTd41nqvv",
    "aws_user_pools_web_client_id": "2fh0jeudhfbcmq2ae5te7314t7",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "nuclear-power-plant-20200508125339-hostingbucket-test",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://nuclear-power-plant-20200508125339-hostingbucket-test.s3-website-us-east-1.amazonaws.com",
    "aws_user_files_s3_bucket": "mav-tempplant-test",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
